export default {
  PRIMARY: 'black',
  WHITE: 'white',
  GREY: '#d8d8d9',
  RED: 'red'
};
